import { render, staticRenderFns } from "./Landing.vue?vue&type=template&id=d10e40b8&scoped=true&"
import script from "./Landing.vue?vue&type=script&lang=js&"
export * from "./Landing.vue?vue&type=script&lang=js&"
import style0 from "./Landing.vue?vue&type=style&index=0&id=d10e40b8&prod&lang=less&"
import style1 from "./Landing.vue?vue&type=style&index=1&id=d10e40b8&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d10e40b8",
  null
  
)

export default component.exports